import { render, staticRenderFns } from "./papanicolauHistoryEdit.vue?vue&type=template&id=0920a6ab&"
import script from "./papanicolauHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./papanicolauHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports